import { render, staticRenderFns } from "./CustomImage.component.vue?vue&type=template&id=3fe725c7&scoped=true"
import script from "./CustomImage.component.vue?vue&type=script&lang=ts"
export * from "./CustomImage.component.vue?vue&type=script&lang=ts"
import style0 from "./CustomImage.component.vue?vue&type=style&index=0&id=3fe725c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe725c7",
  null
  
)

export default component.exports